import { type PartnerResItem, type PartnerTreeNodeV2 } from '@sr/types';
import { joinNameAndDescription } from '@sr/utils';
import { getMergedChild, isMergedItem, LocationCountTemplate } from './utils';

export const getNameAndTextForFnoPartner = (
  partner: PartnerTreeNodeV2,
  level: number,
  parentName?: string,
) => {
  const _isMergedItem = isMergedItem(partner);

  return {
    nameAndText: getNameAndText(partner, level, _isMergedItem, parentName),
    addressAndId: getAddressAndId(partner, _isMergedItem),
  };
};

const getNameAndText = (
  partner: PartnerTreeNodeV2,
  level: number,
  _isMergedItem: boolean,
  parentName?: string,
) => {
  let nameAndText = '';

  if (level === 0) {
    nameAndText = partner.item.name.trim();
    nameAndText = appendDescription(nameAndText, _isMergedItem, partner);
  }

  if (level > 0) {
    if (removePrefixForCompare(parentName) !== removePrefixForCompare(partner.item.name)) {
      nameAndText = partner.item.name.trim();

      nameAndText = appendDescription(nameAndText, _isMergedItem, partner);
    } else {
      nameAndText = (partner.item.description || partner.item.name).trim();

      if (_isMergedItem) {
        const childDescription = getChildDescription(partner);

        if (childDescription) {
          nameAndText = childDescription.trim();
        }
      }
    }
  }

  return nameAndText;
};

const appendDescription = (
  nameAndText: string,
  _isMergedItem: boolean,
  partner: PartnerTreeNodeV2,
) => {
  if (!_isMergedItem) {
    return joinNameAndDescription(nameAndText, partner.item.description);
  }

  return appendChildDescription(nameAndText, partner);
};

const appendChildDescription = (nameAndText: string, partner: PartnerTreeNodeV2) =>
  joinNameAndDescription(nameAndText, getChildDescription(partner));

const getAddressAndId = (partner: PartnerTreeNodeV2, _isMergedItem: boolean) => {
  let addressAndId = '';
  const isAddress = partner.item.type === 'DELIVERYADRESS';

  if (isAddress) {
    addressAndId = `${getAddrFromItem(partner.item)} (${getParentBPId(partner.item.dwKey)})`;
  } else if (_isMergedItem) {
    addressAndId = `${getAddrFromItem(getMergedChild(partner)?.item)} (${partner.item.id})`;
  } else {
    addressAndId = `${LocationCountTemplate} (${partner.item.id})`;
  }

  return addressAndId;
};

const getAddrFromItem = (item?: PartnerResItem) => {
  if (!item) {
    return '';
  }

  let desc = '';

  desc += item.street;
  desc += item.street ? ', ' : '';
  desc += item.city;

  return desc;
};

const getParentBPId = (partnerId: string) => {
  const [, bpId] = partnerId.split('_');

  return bpId;
};

const getChildDescription = (partner: PartnerTreeNodeV2) =>
  getMergedChild(partner)?.item.description;

const removePrefixForCompare = (name?: string) => {
  if (!name) {
    return '';
  }

  return name.replace('(s)', '').trim();
};
